export const userRoles = [
  { id: 'ROLE_USER', name: 'Membre' },
  { id: 'ROLE_ADMIN', name: 'Administrateur' },
  { id: 'ROLE_MANAGER', name: 'Manager' },
  { id: 'ROLE_SELLER', name: 'Sales' },
]

export const DATA_POOL_INTERVAL = 1000*30;
